import { IObjectKey } from "src/app/modules/shared/models/objects";
import { EPolicyTypes, IPolicyFilter } from "src/app/modules/shared/models/policy.model";

export const policy_search_keys: IObjectKey[] = [
    {
        label: 'Numero polizza Compagnia',
        key: 'companyPolicyId'
    },
    {
        label: 'Prodotto',
        key: 'productDescription'
    },
    {
        label: 'Data emissione',
        key: 'emissionDate',
        pipe: {
            key: 'date',
            value: null
        }
    },
    {
        label: 'Data decorrenza',
        key: 'effectDate',
        pipe: {
            key: 'date',
            value: null
        }
    },
    {
        label: 'Data scadenza',
        key: 'expiryDate',
        pipe: {
            key: 'date',
            value: null
        }
    }
]

export const subject_search_keys_PF: IObjectKey[] = [
    {
        label: 'NDG',
        key: 'ndg'
    },
    {
        label: 'Codice fiscale',
        key: 'taxCode',
        hidden: true
    },
    {
        label: 'Data di nascita',
        key: 'birthDate',
        pipe: {
            key: 'date',
            value: null
        }
    },
    {
        label: 'Tipologia',
        key: 'type'
    }
]

export const subject_search_keys_PG: IObjectKey[] = [
    {
        label: 'NDG',
        key: 'ndg'
    },
    {
        label: 'Partita IVA',
        key: 'vatCode',
        hidden: true
    },
    {
        label: 'Tipologia',
        key: 'type'
    }
]

export const BADGE_STYLE_PREFIX = 'badge-';

export const policy_types_filter: IPolicyFilter[] = [
    {
        label: EPolicyTypes.TRADIZIONALE,
        originalStyle: 'badge-tradizionali',
        currentStyle: 'badge-tradizionali',
        policyTypes: [EPolicyTypes.TRADIZIONALE]
    },
    {
        label: EPolicyTypes.PREVIDENZIALI,
        originalStyle: 'badge-previdenziali',
        currentStyle: 'badge-previdenziali',
        policyTypes: [EPolicyTypes.PREVIDENZIALI, EPolicyTypes.PIP]
    },
    {
        label: EPolicyTypes.MULTIRAMO,
        originalStyle: 'badge-multiramo',
        currentStyle: 'badge-multiramo',
        policyTypes: [EPolicyTypes.MULTIRAMO]
    },
    {
        label: EPolicyTypes.TCM_PPI,
        originalStyle: 'badge-tcm',
        currentStyle: 'badge-tcm',
        policyTypes: [EPolicyTypes.TCM_PPI, EPolicyTypes.TCM]
    },
    {
        label: EPolicyTypes.UNIT,
        originalStyle: 'badge-unit',
        currentStyle: 'badge-unit',
        policyTypes: [EPolicyTypes.UNIT]
    },
    {
        label: EPolicyTypes.LTC,
        originalStyle: 'badge-ltc',
        currentStyle: 'badge-ltc',
        policyTypes: [EPolicyTypes.LTC]
    }
]

export const ANAGRAFICHE_MAX_LENGTH: number = 20;
export const ANAGRAFICHE_WARN_MESSAGE: string = "Attenzione! Sono mostrati solo i primi " + ANAGRAFICHE_MAX_LENGTH + " risultati della ricerca";
export const SUBJECTS_ACCREDITAMENTO_WARN_MESSAGE: string = "Non è possibile visualizzare tutti i risultati della ricerca a causa del mancato accreditamento";
export const POLICIES_ACCREDITAMENTO_WARN_MESSAGE: string = "Il cliente ricercato non risulta accreditato";
